import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ToastProvider from './components/controls/Toast/ToastProvider';
import { QRScannerProvider } from './configurations/useQRScanner';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ToastProvider>
    <QRScannerProvider>
      <App />
    </QRScannerProvider>
  </ToastProvider>
);
